import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { AuthenticationModule } from '@core/authentication/authentication.module';
import { PrimengModule } from '@shared/primeng.module';
import { API_PLATFORM_URL, API_URL } from '@core/config/api-base-url';
import { MainComponent } from '@core/components/main/main.component';
import { environment } from '@env/environment';
import { ENV } from '@env/environment-token';
import {
  FeatureToggleModule,
  LibComponentsModule,
  LibPipeModule,
  LocalStorageService,
  ODataService,
  SecurityModule,
} from '@mynexus/mynexus-ui-lib';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MetricsComponent } from './feature/metrics/metrics.component';
import { RulesTableComponent } from './feature/routing-rules/rules-table/rules-table.component';
import { TableExpandedViewComponent } from '@shared/components/table-expanded-view/table-expanded-view.component';
import { JoinPipe, TitleCasePipe } from '@shared/pipes';
import { QueueComponent } from './feature/queue/queue.component';
import { ProductSelectionComponent } from '@core/components/product-selection/product-selection.component';
import { TableActionButtonsComponent } from '@shared/components/table-action-buttons/table-action-buttons.component';
import { TitleStrategy } from '@angular/router';
import { CustomTitleStrategy } from '@core/services/title-strategy.service';
import { ErrorInterceptor } from '@core/services/error.interceptor';
import { AccessDeniedComponent } from '@core/components/access-denied/access-denied.component';
import { providePrimeNG } from 'primeng/config';
import { Carelon } from '@mynexus/theme';

@NgModule({
  declarations: [
    AppComponent,
    ProductSelectionComponent,
    MetricsComponent,
    RulesTableComponent,
    MainComponent,
    TableExpandedViewComponent,
    TitleCasePipe,
    QueueComponent,
    JoinPipe,
    TableActionButtonsComponent,
    AccessDeniedComponent,
  ],
  bootstrap: [AppComponent],
  schemas: [],
  imports: [
    BrowserModule,
    AppRoutingModule,
    PrimengModule,
    FormsModule,
    LibPipeModule,
    ReactiveFormsModule,
    AuthenticationModule,
    LibComponentsModule,
    FeatureToggleModule.forRoot(API_URL), // Basically peer dependency for SecurityModule
    SecurityModule.forRoot([{ url: API_PLATFORM_URL }], 'access-denied'),
  ],
  providers: [
    ODataService,
    LocalStorageService,
    {
      provide: 'windowRef',
      useValue: window,
    },
    {
      provide: ENV,
      useValue: environment,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
    },
    {
      provide: TitleStrategy,
      useClass: CustomTitleStrategy,
    },
    provideHttpClient(withInterceptorsFromDi()),
    providePrimeNG({
      theme: {
        preset: Carelon,
        options: {
          darkModeSelector: false,
        },
      },
    }),
  ],
})
export class AppModule {}
